import { cn } from "@werkstatt/utils";

export interface AmbientBackgroundProps {
  className?: string;
}

const AmbientBackground = ({ className }: AmbientBackgroundProps) => (
  <div
    aria-hidden
    className={cn(
      "pointer-events-none fixed inset-0 -z-10 overflow-hidden",
      className,
    )}
  >
    <div className="absolute -left-24 -top-24 h-[420px] w-[420px] rounded-full opacity-30 blur-[50px] bg-[radial-gradient(circle,rgb(var(--sphere-accent-rgb-from)),transparent_70%)]" />
    <div className="absolute -bottom-32 -right-16 h-[480px] w-[480px] rounded-full opacity-20 blur-[50px] bg-[radial-gradient(circle,rgb(var(--sphere-accent-rgb-to)),transparent_70%)]" />
  </div>
);
AmbientBackground.displayName = "AmbientBackground";

export { AmbientBackground };
